































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Ajax from "@/lib/ajax";
import SupplierOfferItem from "@/store/entities/booking/supplierOfferItem";
import Util from "@/lib/util";

@Component({
  components: {},
})
export default class CreateOffer extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: 0 }) offerTimeSlotId: number;
  @Prop({ type: Number, default: 0 }) offerId: number;

  courtServices: Array<any> = [];
  supplierOfferItem: SupplierOfferItem = new SupplierOfferItem();
  get payMethods() {
    return this.$store.state.common.paymethods;
  }
  offerDateTypes: Array<any> = [];
  predefinedOrder: string[] = [
    "18洞果岭",
    "9洞果岭",
    "球僮",
    "球车",
    "衣柜",
    "简餐",
    "保险",
    "小费",
    "灯光",
    "6%税费",
  ];
  // 保存订单
  save() {
    console.log("success");
    const sortedServices = this.predefinedOrder.filter((service) =>
      this.courtServices.includes(service)
    );
    console.log(sortedServices, "sortedServices");
    this.supplierOfferItem.services = sortedServices.toString();
    console.log(this.supplierOfferItem.services);
    (this.$refs.supplierOfferForm as any).validate(async (valid: boolean) => {
      console.log(valid, "valid");
      if (valid) {
        if (this.supplierOfferItem.payMethod == 1) {
          this.supplierOfferItem.amount = this.supplierOfferItem.price;
        }
        await this.$store.dispatch({
          type: "supplierOfferItem/update",
          data: this.supplierOfferItem,
        });
        (this.$refs.supplierOfferForm as any).resetFields();
        this.courtServices = [];
        this.$Message.success("编辑报价成功");
        this.$emit("input", false);
        this.$emit("save-success");
      }
    });
  }
  cancel() {
    (this.$refs.supplierOfferForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.supplierOfferItem.offerTimeSlotId = this.$props.offerTimeSlotId;
      this.supplierOfferItem = Util.extend(
        true,
        this.supplierOfferItem,
        this.$store.state.supplierOfferItem.editSupplierOfferItem
      );
      if (this.supplierOfferItem.services) {
        this.courtServices = this.supplierOfferItem.services.split(",");
      }
    }
  }
  async created() {
    let rep = await Ajax.get("/api/services/app/OfferDateType/GetSelectItems");
    this.offerDateTypes = rep.data.result;
  }
  // 验证保证金/预付款
  validateAmount(rule: any, value: any, callback: any) {
    console.log(
      typeof this.supplierOfferItem.payMethod != "undefined" &&
        this.supplierOfferItem.payMethod != 1
    );
    if (
      typeof this.supplierOfferItem.payMethod != "undefined" &&
      this.supplierOfferItem.payMethod != 1
    ) {
      if (this.supplierOfferItem.amount == 0) {
        let text = this.supplierOfferItem.payMethod == 0 ? "保证金" : "预付款";
        callback(new Error(`请输入${text}`));
      }
    }
    callback();
  }
  validateOfferPrice(rule: any, value: any, callback: any) {
    console.log(
      !this.supplierOfferItem.offerPrice,
      "this.supplierOfferItem.offerPrice"
    );
    if (!this.supplierOfferItem.offerPrice) {
      callback(new Error("请输入供应商报价"));
    } else {
      callback();
    }
  }
  supplierOfferRule = {
    offerDateTypeId: [
      {
        type: "number",
        required: true,
        min: 1,
        message: this.L("FieldIsRequired", undefined, this.L("OfferDateType")),
        trigger: "change",
      },
    ],
    offerPrice: [
      {
        type: "number",
        required: true,
        min: 1,
        validator: this.validateOfferPrice,
        trigger: "change",
      },
    ],
    // amount: [
    //   {
    //     required: true,
    //     validator: this.validateAmount,
    //     trigger: "change",
    //   },
    // ],
    payMethod: [
      {
        type: "integer",
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("PayMethod")),
        trigger: "change",
      },
    ],
  };
}
